var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/sidebar-navigation.tsx";
import { IconSwitchVertical } from '@tabler/icons';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Avatar, Divider } from 'soapbox/components/ui';
import Search from 'soapbox/features/compose/components/search';
import ComposeButton from 'soapbox/features/ui/components/compose-button';
import ProfileDropdown from 'soapbox/features/ui/components/profile-dropdown';
import { useAppSelector, useOwnAccount, useLogo } from 'soapbox/hooks';
import { getFeatures } from 'soapbox/utils/features';
import SidebarNavigationLink from './sidebar-navigation-link';
const SidebarNavigation = ({
  className
}) => {
  const logo = useLogo();
  const instance = useAppSelector(state => state.instance);
  const account = useOwnAccount();
  const notificationCount = useAppSelector(state => state.notifications.get('unread'));
  const followRequestsCount = useAppSelector(state => state.user_lists.follow_requests.items.count());
  const dashboardCount = useAppSelector(state => state.admin.openReports.count() + state.admin.awaitingApproval.count());
  const features = getFeatures(instance);
  const hasBubble = useMemo(() => {
    const localBubbleInstance = instance.pleroma.getIn(['metadata', 'federation', 'local_bubble_instances']);
    if (!localBubbleInstance) return false;
    return localBubbleInstance.size > 0;
  }, [instance.pleroma]);
  return /*#__PURE__*/React.createElement("div", {
    className: `flex flex-col gap-2 h-full ${className}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-5 mb-5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, account && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: `/@${account.acct}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: account.avatar,
    size: 36,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ProfileDropdown, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "block text-lg font-bold leading-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 19
    }
  }, account.username, "\xA0", /*#__PURE__*/React.createElement(IconSwitchVertical, {
    className: "inline w-[14px] h-[14px] text-gray-700 dark:text-gray-400",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 47
    }
  }))), /*#__PURE__*/React.createElement(Link, {
    className: "block text-xs underline",
    to: "/settings/profile",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "settings.edit_profile",
    defaultMessage: "Edit profile",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 19
    }
  })))), /*#__PURE__*/React.createElement(Search, {
    openInRoute: true,
    autosuggest: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 shrink min-h-0 overflow-y-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/",
    icon: require('@tabler/icons/home.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.home",
      defaultMessage: "Home",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 17
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 9
    }
  }), features.federating ? /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    icon: logo,
    text: /*#__PURE__*/React.createElement(React.Fragment, null, instance.get('title')),
    to: "/timeline/local",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }) : /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    icon: require('@tabler/icons/world.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.all",
      defaultMessage: "All",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 21
      }
    }),
    to: "/timeline/local",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 13
    }
  }), features.federating && features.bubbleTimeline && hasBubble && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    icon: require('@tabler/icons/hexagon.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.bubble",
      defaultMessage: "Featured",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 21
      }
    }),
    to: "/timeline/bubble",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 13
    }
  }), features.federating && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    icon: require('icons/fediverse.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.fediverse",
      defaultMessage: "Explore",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 21
      }
    }),
    to: "/timeline/fediverse",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 9
    }
  }), account && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/notifications",
    icon: require('@tabler/icons/bell.svg'),
    count: notificationCount,
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.notifications",
      defaultMessage: "Notifications",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 112,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 13
    }
  }), features.conversations && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/conversations",
    icon: require('@tabler/icons/messages.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "column.direct",
      defaultMessage: "Conversations",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 25
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 17
    }
  }), features.bookmarks && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/bookmarks",
    icon: require('@tabler/icons/bookmark.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "column.bookmarks",
      defaultMessage: "Bookmarks",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 25
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 17
    }
  }), features.lists && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/lists",
    icon: require('@tabler/icons/list.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "column.lists",
      defaultMessage: "Lists",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 25
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 17
    }
  }), features.followTags && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/followed_hashtags",
    icon: require('@tabler/icons/hash.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation_bar.tags",
      defaultMessage: "Hashtags",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 150,
        columnNumber: 25
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 13
    }
  }), account.locked && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/follow_requests",
    icon: require('@tabler/icons/user-plus.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation_bar.follow_requests",
      defaultMessage: "Follow requests",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 162,
        columnNumber: 25
      }
    }),
    count: followRequestsCount,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 17
    }
  })), features.profileDirectory && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/directory",
    icon: require('@tabler/icons/folder.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation_bar.profile_directory",
      defaultMessage: "Profile directory",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 13
    }
  }), account?.staff && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/soapbox/admin",
    icon: require('@tabler/icons/dashboard.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.dashboard",
      defaultMessage: "Dashboard",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 21
      }
    }),
    count: dashboardCount,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 13
    }
  }), account && /*#__PURE__*/React.createElement(SidebarNavigationLink, {
    to: "/settings",
    icon: require('@tabler/icons/settings.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tabs_bar.settings",
      defaultMessage: "Settings",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 21
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 202,
      columnNumber: 7
    }
  }), account && /*#__PURE__*/React.createElement(ComposeButton, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 204,
      columnNumber: 9
    }
  }));
};
export default SidebarNavigation;